import sha1 from 'sha1';
import { IM_BOT } from './constants';
import { join, sortBy } from 'lodash';
import { getCurrentTimestamp } from './moment';

export const createConversationId = (userId, botId) => {
	const ids = [userId, botId].sort();
	const text = ids.join("-");
	return `${userId?.substr(0, 10)}-${sha1(text).substr(0, 12)}`;
};

export function getConversationIndex(timeLine, conversationId) {
	return timeLine.findIndex(
		(conversation) => conversation.conversationId === conversationId
	);
};

export function getConversationById(state, conversationId) {
	let timeLine = state.timeLine;
	let index = getConversationIndex(timeLine, conversationId);
	if (index !== -1) {
		return timeLine[index];
	}
	return null;
};


export const createIMConversationId = (participants, selectedDomain) => {
	if (!selectedDomain) throw new Error("selectedDomain is required");
	let userIds = [...participants, selectedDomain];
	const text = join(sortBy(userIds), "-");
	return sha1(text).substring(0, 22);
};

export const createIMConversation = (userId, contact, selectedDomain) => {
	if (!userId && !contact) return;

	const participants = [contact.userId, userId];
	const conversationId = createIMConversationId(participants, selectedDomain);
	const now = getCurrentTimestamp();

	return {
		createdOn: now,
		modifiedOn: now,
		conversationId,
		contact,
		bot: { botId: IM_BOT },
		createdBy: userId,
		participants: participants,
		userDomain: selectedDomain,
	};
};